import { cn } from '@/lib/cn';

type Status = 'live' | 'recent' | 'idle' | 'off';

interface StatusDotProps {
  status?: Status;
  size?: string;
  withRing?: boolean;
  className?: string;
}

/**
 * Presence indicator. PINK for live — never green. Never traffic-light colours.
 * `off` is a hairline ring only.
 */
const STATUS: Record<Status, string> = {
  live: 'bg-pink shadow-signal',
  recent: 'bg-pink/60',
  idle: 'bg-white/30',
  off: 'bg-transparent ring-1 ring-inset ring-white/20',
};

export const StatusDot = ({
  status = 'off',
  size = 'h-2 w-2',
  withRing = false,
  className,
}: StatusDotProps) => (
  <span
    aria-label={`status ${status}`}
    className={cn(
      'inline-block rounded-full',
      STATUS[status],
      withRing && 'ring-2 ring-night',
      size,
      className,
    )}
  />
);
